// extracted by mini-css-extract-plugin
export default {"checkbox":"checkbox_checkbox__Ilsfh","label_disabled":"checkbox_label_disabled__wL6k5"};